import {
  setActiveAvito,
  setDataAvito,
  setIsConnected,
  setIsErrorAvito,
  setIsLoading,
  setIsLoadingContent,
  setUpdateAvito,
} from "../../../../store/slices/avitoSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

// Привязка авито
export const initAvito = (dataAvito, errorMessage) => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    $authHost
      .post(`/integrations/avito/initialization`, dataAvito)
      .then((res) => {
        if (res.data.code === 200) {
          dispatch(setIsLoading(false));
          dispatch(setIsConnected(true));
          dispatch(getAvitoIntegrations(dataAvito.userId));
        }
      })
      .catch((error) => {
        dispatch(setIsLoading(false));
        if (error.response) {
          if (error.response.status === 401) {
            dispatch(removeUser());
          } else if (error.response.status === 500) {
            errorToast("Ошибка сервера. Попробуйте позже.");
          }
        } else if (error.request) {
          errorToast("Проблемы с подключением. Проверьте интернет.");
        } else {
          errorToast("Произошла неизвестная ошибка.");
        }

        errorMessage();
        console.error(
          "Error initAvito:",
          error.response?.data?.message || error.message
        );
      })
      .finally(() => {
        dispatch(setIsLoading(false));
      });
  };
};

// Получение списка интеграций
export const getAvitoIntegrations = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/avito/list?userId=${userId}`
      );

      if (data.code === 200) {
        dispatch(setDataAvito(data.users));
      } else {
        errorToast(`Ошибка: ${data.message || "Неизвестная ошибка"}`);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.error("error get avito integrations", error);
    }
  };
};

// Получение конкретной интеграции
export const getAvitoIntegration = (userId, externalAvitoId) => {
  return async (dispatch) => {
    dispatch(setIsErrorAvito(false));
    dispatch(setIsLoadingContent(true));
    try {
      const { data } = await $authHost.get(
        `/integrations/avito?userId=${userId}&externalAvitoId=${externalAvitoId}`
      );

      if (data.code === 200) {
        dispatch(setIsLoadingContent(false));
        localStorage.setItem("dataAvito", JSON.stringify(data.user));
        dispatch(setActiveAvito(data.user));
      } else {
        dispatch(setIsErrorAvito(true));
        errorToast(`Ошибка: ${data.message || "Неизвестная ошибка"}`);
      }
    } catch (error) {
      dispatch(setIsLoadingContent(false));
      dispatch(setIsErrorAvito(true));

      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.log("error getAvitoIntegration", error);
    }
  };
};

// Редактирование авито
export const configureAvitoClient = (configuration, externalAvitoId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/avito/client`,
        configuration
      );

      if (data.code === 200) {
        dispatch(getAvitoIntegration(userId, externalAvitoId));
        dispatch(setUpdateAvito(false));
      } else {
        errorToast(`Ошибка: ${data.message || "Неизвестная ошибка."}`);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.log("configureAvitoClient error:", error);
    }
  };
};

// Деактивация авито
export const deactivateAvito = (dataDeactivation, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/avito/deactivation`,
        dataDeactivation
      );

      if (data.code === 200) {
        setLoading(false);
        dispatch(setIsConnected(false));
        dispatch(setActiveAvito(null));
        navigate("/integration");
        dispatch(getAvitoIntegrations(dataDeactivation.userId));
      } else {
        errorToast(`Ошибка: ${data.message || "Неизвестная ошибка."}`);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
          errorToast("Ошибка авторизации. Пожалуйста, войдите снова.");
        } else if (error.response.status === 404) {
          errorToast(
            "Интеграция не найдена. Возможно, она уже деактивирована."
          );
          dispatch(setIsConnected(false));
          dispatch(setActiveAvito(null));
          navigate("/integration");
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      setLoading(false);
      console.log("deactivateAvito error:", error);
    }
  };
};

// Синхронизация авито
export const synchronizationAvito = (dataSync, setLoading) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/avito/synchronization`,
        dataSync
      );

      if (data.code === 200) {
        setLoading(false);
        dispatch(setActiveAvito(data.user));
        localStorage.setItem("dataAvito", JSON.stringify(data.user));
        dispatch(getAvitoIntegrations(dataSync.userId));
      } else {
        errorToast(
          `Ошибка: ${data.message || "Не удалось выполнить синхронизацию."}`
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
          errorToast("Ошибка авторизации. Пожалуйста, войдите снова.");
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      setLoading(false);
      console.log("synchronizationAvito error:", error);
    }
  };
};
